// extracted by mini-css-extract-plugin
export default {"cell":"FeeConfig_cell__3skeq","title":"FeeConfig_title__I0Y9v"};